import { computed, inject, Injectable, signal } from "@angular/core";
import { AccGoalDetails } from "@interfaces";
import { AppService, FuncService } from "../../../../../services";


@Injectable({ providedIn: 'root' })
export class GoalDetailsDialogDataService {

	private func = inject(FuncService);
	private app = inject(AppService);
	public goalDetails = signal<AccGoalDetails | undefined>(undefined);

	async loadDetails(accGoalId: number) {
		const details = await this.func.accGoal.getDialogData({ accGoalId });
		this.goalDetails.set(details);
	}

	public canEdit = computed(() => this.app.data().permissions.canFacilitateCohorts)
}